import { ElMessage } from 'element-plus'
import lang from '@/lang/index'
import config from '@/config/user.env.js'
import uploadList from './themes/UploadList'
import tenant from './themes/Tenant'
// import Msg from './themes/Msg';
import App from './themes/App'
import cookies from 'js-cookie'
import { getCargoOwnerInfo, setInitResources, getInitResources } from '@/utils/auth'
import { getUserOrgDataByAnhzCode } from '@/api/systemManage/userManagement.js'
import { checkMip, getCustomerInfo, queryUseBucketNameList } from '@/api/user.api.js'
import { getLogIn, getAllResources } from '@/api/login.js'
import router from '@/router/index'
import { useMessageCenter } from '@/message/useMessageCenter'
import { filterMenus } from '@/utils/route.module'
let temOrgList = []
export default {
    state: {
        user: {},
        authority: '',
        appId: config.appId,
        lang: {},
        tenantInfo: {
            customCode: 'annto',
            id: 291,
            sourceTenantCode: 'T201904230000000014',
            tenantCode: 'annto',
            tenantDomain: 'an-uat.midea.com',
            tenantName: '安得智联',
        },
        currentTenant: {
            customCode: 'annto',
            defaultTenantFlag: 0,
            id: 291,
            sourceTenantCode: 'T201904230000000014',
            tenantAdminFlag: 1,
            tenantCode: 'annto',
            tenantDomain: 'an-uat.midea.com',
            tenantName: '安得智联',
        },
        currentApplicationCode: '',
        btnPermissions: null,
        supplier: {},
        locale: '',
        langInfo: {},
        switchs: [],
        oss: {
            buckey: 'c-ntp',
            publicRead: 1,
        },
        identityInfo: {
            id: '',
            isHz: true, // true： 货主， false： 平台
            anhzCode: '',
            customerCode: '',
            customerName: '',
            siteCode: '',
            siteName: '',
            mobile: '',
            privacyAgreementTime: '',
            invoiceFlag: 0, // integer, 货主是否开票标识， 0: 开票，1: 不开票
            needInvoice: true, // boolean, 开票标识
            outerAnhz: '', // 是否是外部货主  1 是   0否
            plantChannel: '', // 网货渠道字段  默认0天津安得，0：天津安得、1：路歌、2：聚盟、3：G7、4：怡亚通
        },
        isCollapse: false,
        siteList: [],
        orgList: [],
        ...tenant.state,
        // ...Msg.state,
        ...uploadList.state,
        ...App.state,
    },
    getters: {
        isHz: state => state.user.identityInfo.isHz,
        user: state => state.user,
        appId: state => state.appId,
        authority: state => state.authority,
        identityInfo: state => state.identityInfo,
        isOuterAnhz: state => +state.identityInfo.outerAnhz === 1,
        plantChannel: state => state.identityInfo.plantChannel,

        menus: state => {
            return filterMenus(state.authority || [])
        },
        lang: state => state.lang,
        tenantInfo: state => state.tenantInfo,
        currentTenant: state => state.currentTenant,
        btnPermissions: state => state.btnPermissions,
        applicationCode: state => {
            const currentPath = state.appList.find(item => {
                if (item.applicationDomain) {
                    return item.applicationDomain.indexOf(window.location.pathname) >= 0
                }
                return false
            })
            return currentPath ? currentPath.applicationCode : ''
        },
        supplier: state => state.supplier,
        locale: state => state.locale,
        langInfo: state => state.langInfo,
        systemSwitchs: state => state.switchs,
        ...tenant.getters,
        // ...Msg.getters,
        ...uploadList.getters,
        ...App.getters,
    },
    mutations: {
        // 获取按钮权限
        getBtnPermissions(state, btnPermissions) {
            state.btnPermissions = btnPermissions
        },
        // 更新当前账号信息
        updateUserInfo(state, user) {
            state.user = user
        },
        // 更新当前货主信息
        updateUserIdentity(state, info) {
            state.identityInfo = {
                id: info.id,
                isHz: +info.flag !== 1, // flag = 0 --> 货主， = 1 --> 平台
                customerCode: info.customerCode,
                customerName: info.customerName,
                siteCode: info.siteCode,
                siteName: info.siteName,
                anhzCode: info.anhzCode,
                mobile: info.mobile,
                companyCode: info.companyCode,
                companyName: info.companyName,
                privacyAgreementTime: info.privacyAgreementTime,
                invoiceFlag: info.invoiceFlag,
                needInvoice: info.invoiceFlag !== 1,
                outerAnhz: info.outerAnhz,
                plantChannel: info.plantChannel,
            }
        },
        updateSiteList(state, list) {
            state.siteList = list
        },
        upOrgList(state, list) {
            state.orgList = list
        },
        // 获取菜单权限
        updateAuthority(state, authority) {
            state.authority = authority
        },
        updateLang(state, _lang) {
            state.lang = _lang
        },
        // 更新租户列表
        updateTenant(state, _tenantInfo) {
            state.tenantInfo = _tenantInfo
        },
        // 更新当前租户
        updateCurrenTenant(state, _tenantInfo) {
            state.currentTenant = _tenantInfo
        },
        // 更新应用编码
        updateCurrentApplicationCode(state, applicationCode) {
            state.currentApplicationCode = applicationCode
        },
        updateSupplier(state, supplier) {
            state.supplier = supplier
        },
        updateLangInfo(state, LangInfo) {
            state.langInfo = LangInfo
        },
        updateLocale(state, locale) {
            // 设置接口的cookie
            cookies.set('lang', locale, { domain: '.midea.com' })
            // 设置时区
            const d = new Date()
            let gmtHours = d.getTimezoneOffset() / 60
            gmtHours = -gmtHours
            let sign = '+'
            if (gmtHours < 0) {
                sign = '-'
            }
            const numLength = 2 // 数字长度 前面补0
            gmtHours = (Array(numLength).join('0') + gmtHours).slice(-numLength)
            cookies.set('timezone', 'GMT' + sign + gmtHours + ':00', { domain: '.midea.com' })
            state.locale = locale
        },
        getSystemSwitchs(state, switchs) {
            state.switchs = switchs
        },
        updateOSS(state, data) {
            state.oss = data
        },
        updateIsCollapse(state, data) {
            state.isCollapse = data
        },
        ...tenant.mutations,
        // ...Msg.mutations,
        ...uploadList.mutations,
        ...App.mutations,
    },
    actions: {
        initTenantsData({ dispatch, commit, state }) {
            return Promise.all([getLogIn(), queryUseBucketNameList()]).then(res => {
                const userResp = res[0]
                const ossResp = res[1]
                if (+userResp.code === 0) {
                    if (JSON.parse(getInitResources())) {
                        commit('getBtnPermissions', getResourceIds(JSON.parse(getInitResources()))) // 缓存权限按钮
                        commit(
                            'updateAuthority',
                            // eslint-disable-next-line max-len
                            JSON.parse(getInitResources())[0] &&
                                JSON.parse(getInitResources())[0].subResources &&
                                JSON.parse(getInitResources())[0].subResources.length
                                ? JSON.parse(getInitResources())[0].subResources
                                : [],
                        )
                    }
                    commit('updateUserInfo', userResp.data)
                    if (ossResp && +ossResp.code === 0) {
                        commit('updateOSS', { bucket: ossResp.data, publicRead: 1 })
                    }
                    return Promise.all([
                        dispatch('initResources'),
                        dispatch('checkCurrentLoginUserIdentity'),
                        dispatch('initGetUserAuthorityData'),
                    ]).then(res => {})
                } else {
                    router.push('/login')
                }
            })
        },
        // eslint-disable-next-line max-lines-per-function
        checkCurrentLoginUserIdentity({ dispatch, commit, state }) {
            const userCode = state.user.userCode.toLocaleLowerCase()
            return checkMip({ userCode: userCode })
                .then(res => {
                    if (res && +res.code === 0) {
                        return res.data
                    } else {
                        ElMessage.error('获取货主平台信息出错')
                        router.push('/login')
                        return false
                    }
                })
                .then(info => {
                    // 货主
                    return getCustomerInfo({
                        pageNo: 1,
                        pageSize: 10,
                        param: {
                            customerCode: info.customerCode,
                            customerName: info.customerName,
                        },
                    }).then(res => {
                        if (!res) {
                            return false
                        }
                        if (res && +res.code === 0) {
                            console.log('info', info)
                            commit(
                                'updateUserIdentity',
                                Object.assign(info, {
                                    siteCode: res.data.records.length ? res.data.records[0].siteCode : '',
                                    siteName: res.data.records.length ? res.data.records[0].siteName : '',
                                    outerAnhz: res.data.records.length ? res.data.records[0].outerAnhz : '',
                                    plantChannel: res.data.records.length ? res.data.records[0].plantChannel : '',
                                }),
                            )

                            const mc = useMessageCenter()
                            mc.post(mc.create('info', '/auth/setup-user-identity', ''))
                        } else {
                            ElMessage.error('获取货主平台信息出错')
                            router.push('/login')
                            return false
                        }
                    })
                })
        },
        // 获取机构
        initGetUserAuthorityData({ commit, state }) {
            return getUserOrgDataByAnhzCode({
                anhzCode: state.user.anhzCode,
                authorityType: '',
                orgName: '',
            }).then(res => {
                if (res && +res.code === 0) {
                    temOrgList = []
                    commit('upOrgList', getOrgList(res.data))
                }
            })
        },
        // 获取菜单
        initResources({ commit, state }) {
            let userInfoObj = {}
            for (const key in JSON.parse(getCargoOwnerInfo())) {
                if (JSON.parse(getCargoOwnerInfo())[key].flag === 0) {
                    userInfoObj = JSON.parse(getCargoOwnerInfo())[key]
                }
            }
            // 统一权限平台配置应用 -- 应用编码
            commit('updateCurrentApplicationCode', 'NTP2022031801')
            return getAllResources({
                userCode: state.user.userCode,
                applicationCode: state.currentApplicationCode,
                tenantCode: state.currentTenant.tenantCode,
                anhzCode: userInfoObj.anhzCode,
            }).then(resData => {
                if (resData && +resData.code === 0) {
                    // 缓存菜单数据
                    setInitResources(resData.data)
                    commit('getBtnPermissions', getResourceIds(resData.data))
                    commit(
                        'updateAuthority',
                        resData.data[0] && resData.data[0].subResources && resData.data[0].subResources.length
                            ? resData.data[0].subResources
                            : [],
                    )
                    if (!resData.data || (resData.data && !resData.data.length)) {
                        const { masterAccountUserCode, masterAccountUserName, masterAccountContactsMobile } = state.user
                        let noPermissionMsg = '当前用户没有菜单权限，请联系客服'
                        if (masterAccountUserCode) {
                            noPermissionMsg = `当前用户没有菜单权限，请联系 ${masterAccountUserName} 分配权限, 电话 ${masterAccountContactsMobile}`
                        }
                        ElMessage.warning({ message: noPermissionMsg, showClose: true })
                        setTimeout(() => {
                            router.push('/')
                        }, 1000)
                    }

                    return true
                } else {
                    ElMessage.error(resData.msg)
                    return false
                }
            })
        },
        UPDATE_LANG({ commit, state }, app) {
            const langSettings = lang.initLanguage(app, state.locale)
            commit('updateLang', langSettings)
            return langSettings
        },
        ...tenant.actions,
        // ...Msg.actions,
        ...uploadList.actions,
        ...App.actions,
    },
}
function getResourceIds(v) {
    const RESOURCE_TYPE_MENU = 3
    const tempArr = []
    getId(v)

    function getId(v) {
        v.forEach(item => {
            if (+item.resourceType === RESOURCE_TYPE_MENU && item.resourceId) {
                tempArr.push(item.resourceId)
            } else if (item.subResources) {
                getId(item.subResources)
            }
        })
    }

    return tempArr
}
function getOrgList(data) {
    if (data && data.length) {
        data.forEach(els => {
            const orgObj = {
                label: els.orgName,
                value: els.orgCode,
                id: els.id,
            }
            temOrgList.push(orgObj)
        })
        if (data.orgChildrens) {
            getOrgList(data.orgChildrens)
        }
    }
    return temOrgList
}
